import * as HttpService from './HttpService'

let namespace = 'company'

export const get = (options, cb, errorCb) => {
    HttpService.get(namespace + '/config', options, cb, errorCb)
}



// WEBPACK FOOTER //
// ./src/services/configService.js